import { Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class MenuItems {
    private openMenuIndex = 0;
    private selectedMenuIndex = -1;
    private selectedSubMenuIndex = -1;

//    {
//        label: 'Shipments', icon: 'local_shipping', link: 'shipments', rights: 'shipments'
//    },


    private menuItems = [
        // {
        //     label: 'Rate Enquiry', icon: 'local_shipping', rights: 'user',link:'/rate-enquiry'            
        // },
        // {
        //     label: 'Orders', icon: 'shopping_cart', rights: 'user',link:'/orders'            
        // },
        // {
        //     label: 'Admin', icon: 'settings',  rights: 'admin',link:'#',
        //     subMenu: [
        //         { label: 'Consignment Rules', icon: '', link: 'consignementRules', rights: 'settings-consignement_rules' },
        //         { label: 'User management', icon: '', link: 'users', rights: 'settings-user_management' },
        //     ]
        // },
//        {
//            label: '-'
//        },
        { 
            label: 'Profile', icon: 'account_circle', link: 'profile', rights: 'user'
        },
        {
            label: 'Logout', icon: 'exit_to_app', link: '/logout', rights: 'user'
        }        
    ];

    constructor() {}

    items() {
        return this.menuItems;
    }

    setOpenMenuIndex(e,subMenu,index: number) {
        if(subMenu === true){
            e.preventDEfault();
        }
        this.openMenuIndex = index;
    }

    getOpenMenuIndex(): number {
        return this.openMenuIndex;
    }

    getSelectedMenuIndex(): number {
        return this.selectedMenuIndex;
    }

    setSelectedSubMenuIndex(index: number) {
        this.selectedMenuIndex = this.openMenuIndex;
        this.selectedSubMenuIndex = index;
    }

    getSelectedSubMenuIndex(): number {
        return this.selectedSubMenuIndex;
    }

    setMenuItems(menu){
        this.menuItems = menu;
    }

    getMenuItems() {
        return this.menuItems;
    }

}